export default "__VITE_ASSET__6DHvZwdT__"